export default {
  blindspotLabel: {
    fontWeight: 300
  },
  blindspotCheckbox: {
    marginRight: '.5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/BlindSpotCheckbox/style.js